<script>
import apiClient from '@/api/clients';
import TrashIcon from '@/components/Icons/TrashIcon.vue';

export default {
  components: {
    TrashIcon,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    facebookCampaignId: {
      type: String,
      required: true,
    },
  },
  methods: {
    confirmDelete() {
      this.$modal.show({
        component: () => import('./RemoveFacebookCampaignDialog.vue'),
        props: {
          action: async () => {
            try {
              await apiClient.delete(`/projects/${this.projectId}/facebook-campaigns`, {
                params: {
                  facebook_campaign_id: [this.facebookCampaignId],
                },
              });

              this.$emit('removed');

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          emailCampaign: this.emailCampaign,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>

<template>
  <BaseButton danger @click="confirmDelete"> <TrashIcon class="w-4 h-4" /> </BaseButton>
</template>
